import { QUESTION_VAN_WESTENDORP, QUESTION_SINGLE } from 'data/nodeTypes';

export const PREDEFINED_VAN_WESTENDORP = 'PREDEFINED_VAN_WESTENDORP';
export const PREDEFINED_LIKELIHOOD = 'PREDEFINED_LIKELIHOOD';
export const RECALL_CHEAP = '{{refId:vw/subRefId:cheap}}';
export const RECALL_EXPENSIVE = '{{refId:vw/subRefId:expensive}}';

export const getVanWestendorpAnswers = (count = 4) => {
  const answers = [
    'so inexpensive that you would question the quality and not consider it?',
    'is a bargain - a great buy for the money?',
    'is getting expensive, but you still might consider it?',
    'would you begin to think the item is too expensive to consider?',
  ];

  if (count === 6) {
    answers.splice(2, 0, 'extra q 1', 'extra q 2');
  }

  return answers;
};

const vanWestendorpQuestions = [
  {
    type: QUESTION_VAN_WESTENDORP,
    prompt:
      'At what price ($USD) would you consider the following product to be...',
    // questions
    answers: getVanWestendorpAnswers(),
  },
];

const likelihoodToPurchaseQuestions = [
  {
    type: QUESTION_SINGLE,
    prompt: `How likely are you to purchase the following product at ${RECALL_CHEAP}?`,
    answers: [
      'Extremely likely',
      'Somewhat likely',
      'Neither likely nor unlikely',
      'Somewhat unlikely',
      'Extremely unlikely',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt: `How likely are you to purchase the following product at ${RECALL_EXPENSIVE}?`,
    answers: [
      'Extremely likely',
      'Somewhat likely',
      'Neither likely nor unlikely',
      'Somewhat unlikely',
      'Extremely unlikely',
    ],
  },
];

export default {
  [PREDEFINED_VAN_WESTENDORP]: vanWestendorpQuestions,
  [PREDEFINED_LIKELIHOOD]: likelihoodToPurchaseQuestions,
};
